import { Bell, Crown } from 'lucide-react';
import { useAuth } from '@/lib/auth';

interface MasterTopbarProps {
  title: string;
  sub?: string;
}

function initialsFromName(name: string | undefined): string {
  if (!name) return 'MR';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function MasterTopbar({ title, sub }: MasterTopbarProps) {
  const { user } = useAuth();
  const initials = initialsFromName(user?.name);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '14px 18px 6px',
      }}
    >
      <div>
        <div
          style={{
            fontSize: 10.5,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            fontFamily: 'var(--font-mono)',
            color: 'var(--lilac-deep)',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            marginBottom: 2,
          }}
        >
          <Crown size={11} strokeWidth={2} /> {sub ?? 'Master'}
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', color: 'var(--fg)' }}>
          {title}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <button
          aria-label="Notificações"
          style={{
            width: 34,
            height: 34,
            borderRadius: '50%',
            background: 'var(--card-soft)',
            border: '1px solid var(--card-stroke)',
            color: 'var(--fg)',
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Bell size={15} strokeWidth={1.7} />
        </button>
        <span
          style={{
            width: 34,
            height: 34,
            fontSize: 11,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, var(--lilac-deep), var(--lilac-2))',
            color: '#fff',
            display: 'grid',
            placeItems: 'center',
            fontFamily: 'var(--font-mono)',
            fontWeight: 600,
          }}
        >
          {initials}
        </span>
      </div>
    </div>
  );
}
